import axios from 'axios';

import { alertError } from './errorMessage';

const instance = axios.create({
	baseURL: '/api'
});

instance.defaults.method = 'POST';
instance.defaults.withCredentials = true;
instance.defaults.responseType = 'json';

// Most pages have no .catch: without this, a failed request leaves their loader spinning silently.
let lastAlert = 0;
instance.interceptors.response.use(undefined, (error) => {
	const serverFailed = !error.response || error.response.status >= 500;
	const aborted = axios.isCancel(error) || error.code === 'ECONNABORTED';
	if (serverFailed && !aborted && Date.now() - lastAlert > 10000) {
		lastAlert = Date.now();
		alertError(error.response || { status: 0 });
	}
	return Promise.reject(error);
});

export default instance;
